import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import * as z from 'zod'

/**
 * Schema for breadcrumb navigation links.
 */
export const BreadcrumbSchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  name: z.string(),
  href: z.string(),
});
function __fc_0(input){return typeof input==="object"&&input!==null&&!Array.isArray(input)&&typeof input["name"]==="string"&&typeof input["href"]==="string";}
var __bf_1={};
function __vb_5(input){var __bv_2,__bv_3,__bo_4;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_1;__bv_2=input["name"];if(!(typeof __bv_2==="string"))return __bf_1;__bv_3=input["href"];if(!(typeof __bv_3==="string"))return __bf_1;__bo_4={"name":__bv_2,"href":__bv_3};return __bo_4;}
var __rfm_z=__zs.safeParse;
function safeParse_BreadcrumbSchema(input){
var __bd_6=__vb_5(input);
if(__bd_6!==__bf_1){return{success:true,data:__bd_6};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_BreadcrumbSchema,__zs,null,__fc_0);
})()

export type Breadcrumb = z.infer<typeof BreadcrumbSchema>
